import * as React from "react";
//import type { PageProps } from "gatsby";
import { Link } from "gatsby";
import Socials from "../utilities/socials";
import Navigation from "../utilities/navigation";

const Footer = () => {
    const socialArray = Object.keys(Socials).map(socialName => ({
        name: socialName,
        ...Socials[socialName],
    }));

    return (
        <footer>
            <section className="nav-bar-bg">
                <div className="max-w-screen-xl px-4 py-12 mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8">
                    <nav className="flex flex-wrap justify-center -mx-5 -my-2">
                        {Navigation.map((item) => (
                            <Link key={item.name} to={item.href} className='px-5 py-2 text-base font-bold text-white hover:text-red-500'>
                                {item.name}
                            </Link>
                        ))}
                    </nav>
                    <div className="flex justify-center mt-8 space-x-8">

                        {socialArray.map((social) => (
                            <a key={social.name} href={social.link} target="_blank" rel={social.name === 'Mastodon' ? "me" : ""} className="font-semibold text-sm text-white hover:text-red-500">
                                {social.icon}
                            </a>
                        ))}

                    </div>
                    <p className="mt-8 text-base leading-6 text-center text-white">
                        {`© ${new Date().getFullYear()} Jeremy King | @NetizenKing. All rights reserved.`}
                    </p>
                    <p className="mt-8 text-base leading-6 text-center text-white">
                        <a href="https://github.com/CodingLime" target="_blank" className='px-5 py-2 text-base text-white hover:text-red-500'>{`Developed by CodingLime.`}</a>
                    </p>
                </div>
            </section>
        </footer>
    );
};

export default Footer;
